import { B2B } from '@frodo/lib/utils/common/constants';
import type { UserInfoType } from '@frodo/models/types';

export const toUserInfo = (response: UserInfoType): UserInfoType => ({
  // TODO: fix this type mismatch
  // @ts-expect-error type mismatch
  hasPermissionUserManagement: false,
  ...response,
  isB2B: (response.type ?? '').toLowerCase() === B2B,
});
